import { render, staticRenderFns } from "./Module1.vue?vue&type=template&id=12c3db32&scoped=true&"
import script from "./Module1.vue?vue&type=script&lang=js&"
export * from "./Module1.vue?vue&type=script&lang=js&"
import style0 from "./Module1.vue?vue&type=style&index=0&id=12c3db32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c3db32",
  null
  
)

export default component.exports